import { ContentState, ContentBlock } from 'draft-js';
import { isMacOS } from '../common';
import React from 'react';

export const LinkDecoratorType = 'LINK';

export const LinkDecorator = (props: React.PropsWithChildren<{ contentState: ContentState, entityKey: string }>) => {
    const { url } = props.contentState.getEntity(props.entityKey).getData();
    const titleSuffix = React.useMemo(() => (isMacOS() ? 'Cmd+Click' : 'Ctrl+Click') + ' to open link in a new tab', []);
    return (
        <a href={url} target='_blank'
            title={`${url}\n${titleSuffix}`}
            onClick={(e) => {
                e.stopPropagation();
                if (isMacOS() && e.metaKey || !isMacOS() && e.ctrlKey) {
                    e.preventDefault();
                    window.open(url, "_blank");
                }
            }}>
            {props.children}
        </a>
    );
};

export const findLinkDecoratorEntities = (contentBlock: ContentBlock, callback: (start: number, end: number) => void, contentState: ContentState) => {
    contentBlock.findEntityRanges(
        (character) => {
            const entityKey = character.getEntity();
            return (
                entityKey !== null &&
                contentState.getEntity(entityKey).getType() === LinkDecoratorType
            );
        },
        callback
    );
}
